var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 43,
    viewBox: "0 0 38 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 0H12C10.9651 0.00353133 10.0051 0.540761 9.46 1.42139L1.46 9.4292C0.552747 9.97241 -0.00190825 10.9535 4.93341e-06 12.0117V39.0381C4.93341e-06 40.6966 1.34315 42.041 3 42.041H35C36.6569 42.041 38 40.6966 38 39.0381V3.00293C38 1.34446 36.6569 0 35 0ZM9 6.12598V9.00879H6.12L9 6.12598ZM35 39.0381H3V12.1118H3.06L3.12 12.0518H12V3.16309L12.06 3.10303V3.04297H34.96L35 39.0381Z",
    fill: "#3f3f51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 23.0225H9C8.17157 23.0225 7.5 23.6947 7.5 24.5239C7.5 25.3532 8.17157 26.0254 9 26.0254H29C29.8284 26.0254 30.5 25.3532 30.5 24.5239C30.5 23.6947 29.8284 23.0225 29 23.0225Z",
    fill: "#3f3f51"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 30.0293H9C8.17157 30.0293 7.5 30.7015 7.5 31.5308C7.5 32.36 8.17157 33.0322 9 33.0322H26C26.8284 33.0322 27.5 32.36 27.5 31.5308C27.5 30.7015 26.8284 30.0293 26 30.0293Z",
    fill: "#3f3f51"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 19.0186H28C29.6569 19.0186 31 17.6741 31 16.0156V10.0098C31 8.35129 29.6569 7.00684 28 7.00684H22C20.3431 7.00684 19 8.35129 19 10.0098V16.0156C19 17.6741 20.3431 19.0186 22 19.0186ZM22 10.0098H28V16.0156H22V10.0098Z",
    fill: "#3f3f51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentUploadIcon);
export default __webpack_public_path__ + "static/media/document-upload-icon.26aad60aa2fa5bef4f9578cd4c025f8d.svg";
export { ForwardRef as ReactComponent };